import {ThunkAction} from 'redux-thunk';
import {IStore} from '../interface';
import {Action} from 'redux';
import {
  createSearchDialogue,
  editSearchDialogue,
  getSearchDialogue,
  getSearchDialogues,
  removeSearchDialogue
} from '../pageAsyncActions';
import {clearErrorAction, finishLoadingAction, startLoadingAction} from '../status/actions';
import {
  setSearchDialogue,
  setSearchDialogues
} from './actions';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {ISearchDialogue} from './interfaces';
import {removeDialogueApi} from '../api/dialogue';
import {
  createSearchDialogueApi,
  editSearchDialogueApi,
  getSearchDialogueApi,
  getSearchDialoguesApi
} from '../api/search';

export const loadSearchDialoguesAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getSearchDialogues;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getSearchDialoguesApi();

      dispatch(finishLoadingAction(actionKey));
      dispatch(setSearchDialogues(data));
    } catch (e) {
      console.log('loadSearchDialoguesAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadSearchDialoguesAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const loadSearchDialogueAction = (id: number): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getSearchDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getSearchDialogueApi(id);

      dispatch(finishLoadingAction(actionKey));
      dispatch(setSearchDialogue(data));
    } catch (e) {
      console.log('loadSearchDialogueAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadSearchDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const createSearchDialogueAction = (dialogue: ISearchDialogue): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    translation: {locale},
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = createSearchDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await createSearchDialogueApi(dialogue, locale);

      dispatch(setSearchDialogue(data));
      dispatch(loadSearchDialoguesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('createSearchDialogueAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.CreateSearchDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const editSearchDialogueAction = (dialogue: ISearchDialogue): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = editSearchDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await editSearchDialogueApi(dialogue);
      dispatch(loadSearchDialoguesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('editSearchDialogueAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.EditSearchDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const removeSearchDialogueAction = (dialogue: ISearchDialogue): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = removeSearchDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await removeDialogueApi(dialogue.dialogId);
      dispatch(loadSearchDialoguesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('removeSearchDialogueAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.RemoveSearchDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});
